var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("base-snackbar", { attrs: { errors: _vm.billingGetErrors } }),
      _c(
        "v-overlay",
        { attrs: { value: _vm.billingGetting, absolute: "" } },
        [
          _c("v-progress-circular", {
            attrs: { indeterminate: "", size: "50", color: "primary" }
          })
        ],
        1
      ),
      _vm.completed
        ? _c("v-alert", { attrs: { type: "success" } }, [
            _c("span", [_vm._v("Completed")])
          ])
        : _vm._e(),
      _c(
        "v-row",
        [
          _c(
            "v-col",
            { attrs: { offset: "11", cols: "1" } },
            [
              _c(
                "v-btn",
                {
                  attrs: { color: "yellow darken-3", block: "", dark: "" },
                  on: { click: _vm.printBill }
                },
                [_c("span", [_vm._v("PRINT")])]
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "3" } },
            [
              _c(
                "v-row",
                [
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text text-uppercase" },
                            [_vm._v("Company Name")]
                          ),
                          _c("v-card-text", [
                            _vm._v(
                              _vm._s((_vm.billingData.customer || {}).company)
                            )
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text text-uppercase" },
                            [_vm._v("Contact Name")]
                          ),
                          _c("v-card-text", [
                            _vm._v(_vm._s(_vm.billingData.contact_name))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text text-uppercase" },
                            [_vm._v("Phone #")]
                          ),
                          _c("v-card-text", [
                            _vm._v(_vm._s(_vm.billingData.contact_number))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text text-uppercase" },
                            [_vm._v("Fax #")]
                          ),
                          _c("v-card-text", [
                            _vm._v(_vm._s(_vm.billingData.fax_number))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _c(
                    "v-col",
                    { attrs: { cols: "12" } },
                    [
                      _c(
                        "v-card",
                        [
                          _c(
                            "v-card-subtitle",
                            { staticClass: "primary--text text-uppercase" },
                            [_vm._v("Email")]
                          ),
                          _c("v-card-text", [
                            _vm._v(_vm._s(_vm.billingData.email))
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "v-col",
            { attrs: { cols: "9" } },
            [
              _c("v-simple-table", {
                attrs: { dense: "" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function() {
                      return [
                        _c("thead", [
                          _c("tr", [
                            _c("th", [_vm._v("Item")]),
                            _c("th", [_vm._v("Invoice No")]),
                            _c("th", [_vm._v("Date")]),
                            _c("th", [_vm._v("Particulars")]),
                            _c("th", [_vm._v("Status")]),
                            _c("th", { staticClass: "text-right" }, [
                              _vm._v("Amount")
                            ])
                          ])
                        ]),
                        _c(
                          "tbody",
                          [
                            _vm._l(_vm.billingData.details, function(
                              detail,
                              index
                            ) {
                              return _c("tr", { key: detail.id }, [
                                _c("td", [_vm._v(_vm._s(index + 1))]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s(_vm.drFormat(detail.invoice_id))
                                  )
                                ]),
                                _c("td", [
                                  _vm._v(
                                    _vm._s((detail.date || "").dateFormat())
                                  )
                                ]),
                                _c("td", [_vm._v(_vm._s(detail.particulars))]),
                                _c(
                                  "td",
                                  {
                                    class:
                                      _vm.statusColorCode(detail) + "--text"
                                  },
                                  [_vm._v(_vm._s(detail.status))]
                                ),
                                _c("td", { staticClass: "text-right" }, [
                                  _vm._v(
                                    _vm._s((detail.amount || 0).phpFormat())
                                  )
                                ])
                              ])
                            }),
                            _c("tr", [
                              _c("th", { attrs: { colspan: "4" } }, [
                                _vm._v("Total")
                              ]),
                              _c("th", { staticClass: "text-right" }, [
                                _vm._v(
                                  _vm._s((_vm.totalAmount || 0).phpFormat())
                                )
                              ])
                            ])
                          ],
                          2
                        )
                      ]
                    },
                    proxy: true
                  }
                ])
              })
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }